export const PlannerGlobals = {
  LENGTHOF1PX: undefined,
  allRooms: undefined,
  CURRENT_MATERIALS: undefined,
  measurements: [],
  DEVICE_SIZE_MOD: 25,
  DEVICE_SIZE_MODS: {
    25: { next: 200, btn: "s" },
    100: { next: 25, btn: "m" },
    150: { next: 100, btn: "l" },
    200: { next: 150, btn: "xl" },
  },
  comfortLevel: 2,
  wallModConnections: [],
  /**
   * The width/height of the devices placed on the map
   */
  DEVICE_SIZE: 10,
  /**
   * The array of placed devices
   * @type {Device[]}
   */
  devices: [],
  outerWallIds: [],
  modifiedOuterWalls: [],
  outerBorder: [],
  /**
   * Contains the current scaling of the plan.
   */
  scalevar: 1,
  /**
   * Self explanatory, used for the drawing process.
   */
  isDragging: false,

  /**
   * @type {Room[]}
   * An array that contains the currently displayed planner's rooms.
   * DOESN'T include Outdoors or Unassigned! Those can be found with uDev.roomsExtended
   */
  rooms: [],

  /**
   * contains the device groups, each having a unique identifier, and an array with the devices' and serials' uniquie identifiers, complete with the identifier's type (ser or dev)
   * eg. groups = [id: 1, connections: [{type: 'dev', uid: 1}, {type: 'ser, uid: 1}]] -> connects device with id 1 to serial with id 1
   */
  /**
   * @type {Group[]}
   */
  groups: [],

  /**
   * contains serialized devices, aka. "snapped together" devices
   * @type {Serial[]}
   */
  serials: [],
  lastRatioPoints: null,
  /**
   * contains the current mode of the planner
   */
  mode: 'basic',
  drawPanInterval: null,
  isDrawing: false,

  //entityselect
  entitySelectType: undefined,
  entitySelectStartPos: undefined,
  entitySelectEndPos: undefined,
  entitySelectHadSuccess: false,

  selectRoomBeginMatSaveState: {},
  wallSelectStartPos: undefined,
  wallSelectEndPos: undefined,

  //roomCurrentHsvMod
  hsvIndexes: {},
  HSV_INCREMENT: 130,
  /**
   * @type {WallSegmentation}
   */
  wallSegmentation: null,
  wallsForWifiCalc: null,
  //ctrl+c, ctrl+v
  clipboard: {},
  /**
   * @type {LightingCalcTransfer}
   */
  LIGHTING_CALC: null,
  // symbols
  symbols_on: false,
  notes_on: false,
  /**
   * @type {Room}
   */
  modifiedRoom: undefined,
  /**
   * @type {any[]}
   */
  modifiedPoly: undefined,
  leftoutAlertShown: undefined,
  zoom: undefined,
  drag: undefined,
  dragstartState: {},
  draggingRoomCircle: undefined,
  draggingSomething: undefined,
  /**
   * @type {Wall}
   */
  draggedWall: null,
  draggedRoomCircle: undefined,
  /**
   * Starting the drag of a circle for modifying the room
   */
  dragRoomCircle: undefined,
  wallSelectModData: [],
  dragWallSelectLine: undefined,
  /**
   * the outer svg (plannersvg)
   * @type {d3.Selection<any>}
   */
  svg: undefined,
  /**
   * #containerSVG
   * @type {d3.Selection<any>}
   */
  container: undefined,

  plannerProjectId: undefined,
  /**
   * contains the current floor's id
   */
  plannerFloorId: undefined,

  userRoleInProject: undefined,

  /**
   * states whether the planner was called on a quote page or not (for showing extra details, being read-only)
   */
  isInQuote: undefined,
  wallInput: null,
  entitySelectClosestPt: null,
  entitySelectClosestPts: null,
  entitySelectStartRoom: null,
  plannerOpacity: 0.7,
  plannerEditableWallViewEnable: false,
  /**
   * @type {Note[]}
   */
  notes: [],
  wallToolTimeout: undefined,
  /**
   * @type {PlannerHistoryManager}
   */
  plannerHistoryManager: undefined,
  /**
   * @type {Object.<number, Object.<number, Device[]>>}
   */
  roomDevs: {},
  /**
   * @type {SerialConnection[]}
   */
  serialConnections: [],
  mergedDevice: [],
  editPictureHelper: undefined,
  dragNoteBehavior: undefined,
  panDisable: false,
  selectionBeforeDrag: null,

  DRAG_HELPER: {
    draggedD3Dev: null,
    draggedNote: null,
    dragStartRoomId: null,
    dragStartMode: null,
    /**
     * @type {Point}
     */
    deviceCursorDiff: null,
    draggedD3This: null,
  },
  GHOST_DEV_PARAMS: null,
  sizeErrorHelper:  {
    errorCorrectMode: false,
    badFromBeginning: false,
    endCallback: null,
    problemDevices: {},
    normalModdedDevices: {},
    lastGoodRatioPoints: {},
    lastGoodLengthOf1Px: 0,
    lastGoodScaleMod: 0,
    moddingTo: 0,
    alldevs: [],
    devBackup: [],
    userZoomed: false,
  },
  setSizeTimeout: undefined,
  wizard_items: {},
  mouseDownTranslate: undefined,
  mouseDownPageXY: undefined,
  planner_maxZoom: 30,
  measureSuccess: false,
  measurement_types: [],
  measurements_on: true,
  /**
   * helper variable for making the red x disappear over time
   */
  hideRedXTimeout: null,
  changedWalls: {},
  /**
   * Contains the current translation of the plan.
   */
  translatevar: [0, 0],
  drawRoomStartPoint: null,
  drawRoomPoints: [],
  g: null,
  DRAW_PAN_TIME: 50,
  selectRoomUndoArr: [],

  //groupme
  groupMeSourceId: undefined,
  groupMeStartMousePt: undefined,
  groupMeXY: undefined,
  currentlySelectedElement: undefined,
  /**
   * helper variable for blocking moving the plan
   */
  prevTranslate:  [0, 0],

  prevScale: 1,

  //variables used for modifying rooms
  modifying: undefined,
  entitySelectPreventOnce: false,

  lastNoteIdMouseOver: null,
  lastDevIdMouseOver: null,

  noteClipBtnTimeout: null,
  hasDraggedNote: false,
  dragOuterWallCircle: undefined,
  /**
   * Used for dragging elements, contains the room's polygon in which the device was originally in.
   */
  currentPoly: undefined,
  /**
   * When dragging a device, we save the original position of it,
   * in case the user drags it to an invalid position, we can restore it to its original one.
   */
  deviceOrigiPosition: undefined,
  outOfRoomAlertShown: undefined,
  hasDraggedDev:  false,

  CURR_REDRAW_COUNTER: 0,
  CAN_REDRAW_EVERY_FRAME: 2,
  DRAG_DEV_START_ROTATION: undefined,
  wifibtn_exists: false,
  isScaleChecked:  0,
  /**
   * @type {Worker}
   */
  OUTERWALL_WORKER:  undefined,
  // NOTE: isMobile is false at module-eval (initController runs later), so this was already 4.
  // Inlined to keep planner-globals.js worker-safe (no controller.js / jQuery import).
  DRAW_CIRCLE_R: 4,
  DRAW_CIRCLE_STROKE_WIDTH: 1,
  MODIFY_POLYLINE_STROKE: 2,
  calcOuterPromise: null,
  lastCalculatedOuterWall:  null,
  lastCalculatedOuterWallTimeout: null,

  bulkDevDesignChanger: null,
  rotateMeTool: undefined,
  rotateMeToolTransform: undefined,
  rotateMeTimeout: null,
  floorHeadroom:  null,
  /**
   * The current state of the cursor over the SVG element.
   * This is not adjusted for zooming and panning. Use GetXYCorrig() for that.
   */
  XY: [-1, -1],
  DEVICE_SIZE_MOD_SERVER: undefined,
  PLANNER_ZEN_MODE: false,
  /**
   * @type {"loxone" | "conventional" | "it"}
   */
  systemFieldOfInterest: "loxone",
  /**
   * @type {"metric" | "imperial"}
   */
  PLANNER_MEASUREMENT_SYSTEM: "metric",
  toolbarIdStates: {},

  AUTOPAN_OVER_INVALID: false,

  roomContainer: undefined,

  sliderPressed: undefined,

  /**
   * planner's opacity (in percent)
   */
  plannerOpacityIdx: 0,
  plannerOpacities: [100, 70, 50, 30, 0],
  planNamesShown: true,
  planGridShown: true,

  drawd3e: undefined,

  serverConfirmedRatioPoints: undefined,

  plannerIsLoaded: false,
  quoteViewBoxCache: {},
  lastGoodRatioPoints: undefined,
  lastGoodLengthOf1Px: undefined,
  lastGoodScaleMod: undefined,
  isZooming: false,
  zoomAnimFrame: undefined,
  curr_fake_devid: -100,
  curr_fake_serid: -100,
  plannerIsRemovingDevices: false,
}